import {AutocompleteRecommendationTemplate} from './autocomplete-recommendation.template';
import {AutocompleteNode} from '../model/autocomplete-node.model';
import {fromEvent, Subscription, tap} from 'rxjs';

export class AutocompleteRecommendationDomInjector {
    template = new AutocompleteRecommendationTemplate(this.document, this.autocompleteNode);
    
    private focusStream = fromEvent(this.template.link, 'focus').pipe(
        tap(() => this.autocompleteNode.nodesFocusStream.next(this.autocompleteNode))
    );

    private receivedFocusStream: Subscription;
    
    constructor(
        private document: Document,
        private window: Window,
        private hostElement: HTMLElement,
        private autocompleteNode: AutocompleteNode
    ) {
        this.hostElement.appendChild(this.template.container);
        this.receivedFocusStream = this.focusStream.subscribe();
    }

    focus(): void {
        this.template.link.focus();
    }

    destroy(): void {
        this.receivedFocusStream.unsubscribe();
        this.hostElement.removeChild(this.template.container);
    }
}